import React, { lazy } from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';

// dashboard routing
const DashboardDefault = Loadable(lazy(() => import('views/dashboard/Default')));

// pdfs routing
const Pdfs = Loadable(lazy(() => import('views/pdfs/Default')));

// Plagiarism Checker routing
const PlagiarismChecker = Loadable(lazy(() => import('views/plagiarism-checker')));

// editor routing
const Editor = Loadable(lazy(() => import('views/editor')));

// recognize routing
// const Recognize = Loadable(lazy(() => import('views/recognize')));

// downloads routing
const Downloads = Loadable(lazy(() => import('views/downloads')));

// started routing
const Started = Loadable(lazy(() => import('views/started')));

// screen routing
const Screen = Loadable(lazy(() => import('views/screen')));

// batch ocr routing
const BatchOCR = Loadable(lazy(() => import('views/batch-ocr')));

// seo tool pages routing
const ImageToWord = Loadable(lazy(() => import('views/seo-tools/ImageToWord')));
const ImageToExcel = Loadable(lazy(() => import('views/seo-tools/ImageToExcel')));
const ReceiptOCR = Loadable(lazy(() => import('views/seo-tools/ReceiptOCR')));
const PdfToText = Loadable(lazy(() => import('views/seo-tools/PdfToText')));
const ScreenshotToText = Loadable(lazy(() => import('views/seo-tools/ScreenshotToText')));
const HandwritingToText = Loadable(lazy(() => import('views/seo-tools/HandwritingToText')));

// contact us routing

// ===========================|| MAIN ROUTING ||=========================== //

const MainRoutes = {
  path: '/',
  element: <MainLayout />,
  children: [
    {
      path: '/',
      element: <DashboardDefault />
    },
    {
      path: '/images',
      element: <DashboardDefault />
    },
    {
      path: '/batch-ocr',
      element: <BatchOCR />
    },
    {
      path: '/image-to-word',
      element: <ImageToWord />
    },
    {
      path: '/image-to-excel',
      element: <ImageToExcel />
    },
    {
      path: '/receipt-ocr',
      element: <ReceiptOCR />
    },
    {
      path: '/pdf-to-text',
      element: <PdfToText />
    },
    {
      path: '/screenshot-to-text',
      element: <ScreenshotToText />
    },
    {
      path: '/handwriting-to-text',
      element: <HandwritingToText />
    },
    {
      path: '/screen',
      element: <Screen />
    },
    {
      path: '/pdfs',
      element: <Pdfs />
    },
    {
      path: '/plagiarism-checker',
      element: <PlagiarismChecker />
    },
    {
      path: '/editor',
      element: <Editor />
    },
    {
      path: '/started',
      element: <Started />
    },
    {
      path: '/downloads',
      element: <Downloads />
    }
  ]
};

export default MainRoutes;
